

<template>



	<div class="widget_events_content_day-container">
		
		
		
		<div  class="list_day-wrapper" :id="wrapperId">
		 <div class="list_day"  >
		
			<div  class="day_item" v-for="(events, key) in listEvents" :id='dayID(key)'>

				

				
			 	<div class="dayTitle"><span v-if='isToday(key)'>Today</span> {{ dayTitle(key) }}</div>

			 	<ul :class='classEventList(events)'>

			 	
			 		
			 		<li v-for="event in events">
		
							<div class="event_box_image"  v-if="event.imagelisting"   :class="getColorClass(event.tid, event.parents_id)" >

								<div class="explore_thumb_stories">

									<div class="front">
										<div class="top">
											<img :src="event.imagelisting">
										</div>
										<div class="bottom">
											<h3 v-if="classEventList(events) == 'contain_1_items' " >{{ event.longtitle }}</h3>
											<h3 v-else >{{ event.longtitle | truncate(50) }}</h3>
											<!-- <h4>{{ getCat(event.tid) }}</h4> -->
										</div>	
									</div>

									<div class="hover">
										<div class="close"></div>
										<div class="top">
											<h3 class="fit-text-3">{{event.longtitle}}</h3>
											<!-- <h4>{{ getCat(event.tid)}}</h4> -->
											<p> {{ event.description }} </p>
										</div>	
										<a :href="event.event_url" class="bottom">
											<span>Read More</span>
										</a>
									</div>
											
									
								</div>
							</div> 
							<div class="event_box"  v-else  >
							   <div class="inside">
							      <a :href="event.event_url" class="bg"  :class="getColorClass(event.parents_id)" >
							         <div class="title">{{event.longtitle}}</div>
							         <div class="time">{{event.datetime}}</div>
							      </a>
							   </div>
							</div>

			 		</li>


			 	</ul>

				
			</div> 
		</div> 
		</div>

		<ScrollBar></ScrollBar>
	</div>

</template>

<script>
	
	import store  from './CalendarStoreEvents'
	import moment from 'moment'
	import ScrollBar from '../scrollbar/ScrollBar'
	import scrollBus from '../scrollbar/ScrollBus';

	export default {
	  	name: 'calendar-day',
		data () {
		    return {
		    	date: null,
		    	state: store.state, 
		    	listDays : [],
		    	firstDay: null, 
		    	lastDay: null , 
		    	wrapperId: '',
		    	todayPercent: 100
		    }
		},
		components: {
			ScrollBar
		},
			
		computed:{

			

			today(){
				return moment().format('YYYY-MM-DD');          

			},

			listEvents(){

			 	let unordered = this.state.events

			 	let  ordered = {};
				Object.keys(unordered).sort().forEach(function(key) {
				  ordered[key] = unordered[key];
				});

				
				this.generateScrollId()

				this.$nextTick(function () {
					this.scrollToToday()

					 setTimeout(() => this.getTodayTop(), 100);
					 
				}); 


				

				return ordered


			}, 
			
		}, 
		methods:{
			dayTitle(day){
					return moment(day).format('dddd, MMMM D YYYY')
			},


			isToday(day){
				if(this.today == day){
					return true
				}
			},

			dayID(day){
				if(this.today == day){
					return "isToday"
				}
				else{
					let id = "dayToToday_"
					let diff = moment(day).diff(moment(this.today), 'day')

					return id+diff


				}
			},
			eventsDay(day){
				

			}, 
			getCat(tid){
				return tid
			}, 

			goPast(){
				this.firstDay = moment(this.firstDay).add(-1, 'month')
			},
			goFuture(){
				this.lastDay = moment(this.lastDay).add(1, 'month')
			}, 
			calculateBack(distPerc) {
				var full = 	document.getElementById(this.wrapperId).scrollHeight;
				var client = 	document.getElementById(this.wrapperId).offsetHeight;
				var  holderHeight = full - client;

                let posOfBar = (distPerc * holderHeight) / 100;

                document.getElementById(this.wrapperId).scrollTop = posOfBar;
            },

            getTodayTop(){
            	
        	   	let target; 
            	let topPos = 0
            	let percent; 
            	let height  = jQuery('.list_day-wrapper .list_day').height()

            
            	/* scroll to today*/
	        	if( document.getElementById('isToday') ){
	        		target = document.getElementById('isToday')
	        		topPos = target.offsetTop


	        		let percent = (topPos +500) * 100 / height 
	        		if(percent > 100){
	        			percent = 100; 
	        		}

	        		this.todayPercent = percent; 
					scrollBus.$emit('firstLoad', (percent) ); 
	        	}
	        	else{
	        		
	        		let i = 0
	        		while(i < 500){
	        			
	        			if(document.getElementById('dayToToday_'+i)){
	        				target = document.getElementById('dayToToday_'+i)
	        				break; 
	        			}

	        			i++
	        		}

	        		


	        		if(target){
	        			 topPos = target.offsetTop
	        			 let percent = (topPos +500) * 100 / height 
	        			 if(percent > 100){
		        			percent = 100; 
		        		}
	        			 this.todayPercent = percent; 
	        			

	        			 scrollBus.$emit('firstLoad', (percent) );
	        			
	        		}
	        		else{
	        			 let percent = 100
	        			 this.todayPercent = percent; 
	        			 scrollBus.$emit('firstLoad', (percent) );
	        		}
	        	} 
	        	   
	        	
            },

            scrollToToday(){
            	

            	let target; 
            	let topPos = 0

            	let height  = jQuery('.list_day-wrapper .list_day').height()
            	/* scroll to today*/
	        	if( document.getElementById('isToday') ){
	        		target = document.getElementById('isToday')
	        		topPos = target.offsetTop

	        		let percent = (topPos +500) * 100 / height 

	        		if(percent > 100){
	        			percent = 100; 
	        		}

	        		scrollBus.$emit('change', (percent) );


	        		

	        	}
	        	else{
	        		
	        		let i = 0
	        		while(i < 500){
	        			
	        			if(document.getElementById('dayToToday_'+i)){
	        				target = document.getElementById('dayToToday_'+i)
	        				break; 
	        			}

	        			i++
	        		}     

	        	   	

	        		if(target){
	        			 topPos = target.offsetTop
	        			 let percent = (topPos +500) * 100 / height 
	        			
	        			 scrollBus.$emit('change', (percent) );
	        			
	        		}
	        		else{
	        			 scrollBus.$emit('change', (100) )
	        		
	        		}
	        	}


            }, 
            generateScrollId(){
            	 this.wrapperId = Math.random().toString(36).substring(7);
	            scrollBus.$on('change', (msg) => {
	                this.calculateBack(msg);
	            });
            },

           	getColorClass(tid, parentTid){
				return store.getColorClass(tid, parentTid)
			},

			classEventList(events){
				return 'contain_'+events.length+'_items'
			}, 
			handleScroll(e){
				

				let height  = e.target.scrollHeight
				let client = 	e.target.offsetHeight;
				let maxScroll = height - client;
				let topPos = e.target.scrollTop


				let percent = (topPos) * 100 / maxScroll 

	
			
				scrollBus.$emit('scrollUpdate', (percent) );



			}
		},

		
		mounted () {

			
			this.date = moment()
			this.firstDay 	= moment(this.date).startOf('month')
			this.lastDay 	= moment(this.date).endOf('month')	

			
			
			
			 scrollBus.$on('gotToToday', (msg) => {
			 

				var full = 	document.getElementById(this.wrapperId).scrollHeight;
				var client = 	document.getElementById(this.wrapperId).offsetHeight;
				var holderHeight =  full - client;

			 	  let posToday = (this.todayPercent * holderHeight) / 100;
	                 document.getElementById(this.wrapperId).scrollTop = posToday;
	            });

		
		   
		},

		updated (){
		
			
			document.getElementById(this.wrapperId).addEventListener('scroll', this.handleScroll);

			
		}, 

		

	
	}

</script>


// WEBPACK FOOTER //
// CalendarDay.vue?1bad6efc